import { render, staticRenderFns } from "./saldo-creditos-rodape.vue?vue&type=template&id=5fc7fb5a&scoped=true&"
import script from "./saldo-creditos-rodape.vue?vue&type=script&lang=js&"
export * from "./saldo-creditos-rodape.vue?vue&type=script&lang=js&"
import style0 from "./saldo-creditos-rodape.vue?vue&type=style&index=0&id=5fc7fb5a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc7fb5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc7fb5a')) {
      api.createRecord('5fc7fb5a', component.options)
    } else {
      api.reload('5fc7fb5a', component.options)
    }
    module.hot.accept("./saldo-creditos-rodape.vue?vue&type=template&id=5fc7fb5a&scoped=true&", function () {
      api.rerender('5fc7fb5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ai-framework/components/saldo-creditos-rodape/saldo-creditos-rodape.vue"
export default component.exports